import React from 'react';
import PropTypes from 'prop-types';
import BaseIndicator from './BaseIndicator';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { useTheme } from '@mui/styles';
import { MonitorOff } from 'assets/images';
/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const VideoUnmutedIndicator = ({ tooltipPosition }) => {
  const theme = useTheme();

  return (
    <BaseIndicator
      icon={MonitorOff}
      iconColor={theme.palette.iconError}
      iconId="camera-enabled"
      iconSize={12}
      id="videoUnMuted"
      tooltipKey="videothumbnail.unmute"
      tooltipPosition={tooltipPosition}
    />
  );
};

export default React.memo(withBoundary(VideoUnmutedIndicator));
VideoUnmutedIndicator.propTypes = {
  tooltipPosition: PropTypes.string
};
